import { tKey } from 'ember-intl';

export type ReviewScore = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const SCORE_FALLBACK_TITLE_MAP: Record<ReviewScore, string> = {
  1: tKey('review_manager.sidebar.card.very_poor'),
  2: tKey('review_manager.sidebar.card.poor'),
  3: tKey('review_manager.sidebar.card.bad'),
  4: tKey('review_manager.sidebar.card.disappointing'),
  5: tKey('review_manager.sidebar.card.passable'),
  6: tKey('review_manager.sidebar.card.pleasant'),
  7: tKey('review_manager.sidebar.card.good'),
  8: tKey('review_manager.sidebar.card.very_good'),
  9: tKey('review_manager.sidebar.card.superb'),
  10: tKey('review_manager.sidebar.card.exceptional'),
};

export function isValidReviewScore(score: number): score is ReviewScore {
  return score in SCORE_FALLBACK_TITLE_MAP;
}
